import axios from 'axios';
import Helper from './utils/Helper';
import { history } from './App';
import Const from './utils/Constants';

class AxiosConfig {
    static init() {
        axios.interceptors.response.use((response) => {
            return response;
        }, function (error) {
            // Guard: network errors (CORS, timeout, server down, aborted)
            // produce no `response` object. Without this guard the
            // interceptor itself throws "Cannot read properties of
            // undefined (reading 'status')", masking the real cause.
            const status = error && error.response && error.response.status;
            if (status === 401) {
                localStorage.removeItem(Const.AUTH_TOKEN);
                localStorage.removeItem(Const.USER_EMAIL);
                localStorage.removeItem(Const.GIMAGE_URL);
                localStorage.removeItem(Const.GID);
                history.push(`/login-sign-up?redirectTo=${window.location.pathname}`)
            } else if (status === 403) {
                history.push(`/account`)
            } else if (status === undefined) {
                // Surface network-level failures somewhere visible so
                // they don't disappear silently behind the interceptor.
                console.warn('axios network error (no response)', error && error.message);
            }
            return Promise.reject(error);
        });
    }
}

export default AxiosConfig;
